import { FC } from "react";

import AddressBook from "@topi/ui/assets/svgs/icons/address-book.svg?react";
import ArrowClockwise from "@topi/ui/assets/svgs/icons/arrow-clockwise.svg?react";
import ArrowElbowRightUp from "@topi/ui/assets/svgs/icons/arrow-elbow-right-up.svg?react";
import ArrowFatLinesUp from "@topi/ui/assets/svgs/icons/arrow-fat-lines-up.svg?react";
import ArrowLeft from "@topi/ui/assets/svgs/icons/arrow-left.svg?react";
import ArrowRight from "@topi/ui/assets/svgs/icons/arrow-right.svg?react";
import ArrowsClockwise from "@topi/ui/assets/svgs/icons/arrows-clockwise.svg?react";
import ArrowsOut from "@topi/ui/assets/svgs/icons/arrows-out.svg?react";
import ArrowUpRight from "@topi/ui/assets/svgs/icons/arrow-up-right.svg?react";
import Bacs from "@topi/ui/assets/svgs/icons/bacs.svg?react";
import Bank from "@topi/ui/assets/svgs/icons/bank.svg?react";
import BellRinging from "@topi/ui/assets/svgs/icons/bell-ringing.svg?react";
import Blank from "@topi/ui/assets/svgs/icons/blank.svg?react";
import Barcode from "@topi/ui/assets/svgs/icons/barcode.svg?react";
import Book from "@topi/ui/assets/svgs/icons/book.svg?react";
import Bookmark from "@topi/ui/assets/svgs/icons/bookmark.svg?react";
import CalendarBlank from "@topi/ui/assets/svgs/icons/calendar-blank.svg?react";
import CalendarCheck from "@topi/ui/assets/svgs/icons/calendar-check.svg?react";
import CaretDown from "@topi/ui/assets/svgs/icons/caret-down.svg?react";
import CaretLeft from "@topi/ui/assets/svgs/icons/caret-left.svg?react";
import CaretRight from "@topi/ui/assets/svgs/icons/caret-right.svg?react";
import CaretUp from "@topi/ui/assets/svgs/icons/caret-up.svg?react";
import Chat from "@topi/ui/assets/svgs/icons/chat.svg?react";
import Check from "@topi/ui/assets/svgs/icons/check.svg?react";
import CheckCircle from "@topi/ui/assets/svgs/icons/check-circle.svg?react";
import XCircle from "@topi/ui/assets/svgs/icons/x-circle.svg?react";
import Copy from "@topi/ui/assets/svgs/icons/copy.svg?react";
import CreditCard from "@topi/ui/assets/svgs/icons/credit-card.svg?react";
import Cross from "@topi/ui/assets/svgs/icons/cross.svg?react";
import DotsThree from "@topi/ui/assets/svgs/icons/dots-three.svg?react";
import DotsThreeOutline from "@topi/ui/assets/svgs/icons/dots-three-outline.svg?react";
import Download from "@topi/ui/assets/svgs/icons/download.svg?react";
import DotsThreeOutlineVertical from "@topi/ui/assets/svgs/icons/dots-three-outline-vertical.svg?react";
import ExternalLink from "@topi/ui/assets/svgs/icons/external-link.svg?react";
import Eye from "@topi/ui/assets/svgs/icons/eye.svg?react";
import FallbackImage from "@topi/ui/assets/svgs/icons/fallback-image.svg?react";
import FileText from "@topi/ui/assets/svgs/icons/file-text.svg?react";
import Flag from "@topi/ui/assets/svgs/icons/flag.svg?react";
import Info from "@topi/ui/assets/svgs/icons/info.svg?react";
import InfoRounded from "@topi/ui/assets/svgs/icons/info-rounded.svg?react";
import Laptop from "@topi/ui/assets/svgs/icons/laptop.svg?react";
import Link from "@topi/ui/assets/svgs/icons/link.svg?react";
import List from "@topi/ui/assets/svgs/icons/list.svg?react";
import ListDashes from "@topi/ui/assets/svgs/icons/list-dashes.svg?react";
import Lock from "@topi/ui/assets/svgs/icons/lock.svg?react";
import Logout from "@topi/ui/assets/svgs/icons/logout-icon.svg?react";
import MagnifyingGlass from "@topi/ui/assets/svgs/icons/magnifying-glass.svg?react";
import Medal from "@topi/ui/assets/svgs/icons/medal.svg?react";
import NumberCircleOne from "@topi/ui/assets/svgs/icons/number-circle-one.svg?react";
import NumberCircleTwo from "@topi/ui/assets/svgs/icons/number-circle-two.svg?react";
import NumberCircleThree from "@topi/ui/assets/svgs/icons/number-circle-three.svg?react";
import NumberCircleFour from "@topi/ui/assets/svgs/icons/number-circle-four.svg?react";
import NumberCircleFive from "@topi/ui/assets/svgs/icons/number-circle-five.svg?react";
import PencilSimple from "@topi/ui/assets/svgs/icons/pencil-simple.svg?react";
import Performance from "@topi/ui/assets/svgs/icons/performance.svg?react";
import Plus from "@topi/ui/assets/svgs/icons/plus.svg?react";
import Prohibit from "@topi/ui/assets/svgs/icons/prohibit.svg?react";
import Question from "@topi/ui/assets/svgs/icons/question.svg?react";
import Receipt from "@topi/ui/assets/svgs/icons/receipt.svg?react";
import SepaIcon from "@topi/ui/assets/svgs/icons/sepa_icon.svg?react";
import ShoppingCart from "@topi/ui/assets/svgs/icons/shopping-cart.svg?react";
import SpinnerGap from "@topi/ui/assets/svgs/icons/spinner-gap.svg?react";
import Tag from "@topi/ui/assets/svgs/icons/tag.svg?react";
import Trash from "@topi/ui/assets/svgs/icons/trash.svg?react";
import TrashSimple from "@topi/ui/assets/svgs/icons/trash-simple.svg?react";
import Truck from "@topi/ui/assets/svgs/icons/truck.svg?react";
import User from "@topi/ui/assets/svgs/icons/user.svg?react";
import WarningCircle from "@topi/ui/assets/svgs/icons/warning-circle.svg?react";
import Warning from "@topi/ui/assets/svgs/icons/warning.svg?react";
import Minus from "@topi/ui/assets/svgs/icons/minus.svg?react";

import { Svg } from "./icon.styles";

export const iconTypes = {
  addressBook: AddressBook,
  arrowClockwise: ArrowClockwise,
  arrowElbowRightUp: ArrowElbowRightUp,
  arrowFatLinesUp: ArrowFatLinesUp,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  arrowsClockwise: ArrowsClockwise,
  arrowsOut: ArrowsOut,
  arrowUpRight: ArrowUpRight,
  bacs: Bacs,
  bank: Bank,
  barcode: Barcode,
  bellRinging: BellRinging,
  blank: Blank,
  book: Book,
  bookmark: Bookmark,
  calendarBlank: CalendarBlank,
  calendarCheck: CalendarCheck,
  caretDown: CaretDown,
  caretLeft: CaretLeft,
  caretRight: CaretRight,
  caretUp: CaretUp,
  chat: Chat,
  check: Check,
  checkCircle: CheckCircle,
  copy: Copy,
  creditCard: CreditCard,
  cross: Cross,
  dotsThree: DotsThree,
  dotsThreeOutline: DotsThreeOutline,
  dotsThreeOutlineVertical: DotsThreeOutlineVertical,
  download: Download,
  externalLink: ExternalLink,
  eye: Eye,
  fallbackImage: FallbackImage,
  fileText: FileText,
  flag: Flag,
  info: Info,
  infoRounded: InfoRounded,
  laptop: Laptop,
  link: Link,
  list: List,
  listDashes: ListDashes,
  lock: Lock,
  logout: Logout,
  magnifyingGlass: MagnifyingGlass,
  medal: Medal,
  minus: Minus,
  numberCircleFive: NumberCircleFive,
  numberCircleFour: NumberCircleFour,
  numberCircleOne: NumberCircleOne,
  numberCircleThree: NumberCircleThree,
  numberCircleTwo: NumberCircleTwo,
  pencilSimple: PencilSimple,
  performance: Performance,
  plus: Plus,
  prohibit: Prohibit,
  question: Question,
  receipt: Receipt,
  sepa: SepaIcon,
  shoppingCart: ShoppingCart,
  spinnerGap: SpinnerGap,
  tag: Tag,
  trash: Trash,
  trashSimple: TrashSimple,
  truck: Truck,
  user: User,
  warning: Warning,
  warningCircle: WarningCircle,
  xCircle: XCircle,
} as const;

export type IconName = keyof typeof iconTypes;

interface IconProps {
  title?: string;
  className?: string;
  name: IconName;
}

export const Icon: FC<IconProps> = ({ title, className, name }: IconProps) => {
  const IconType = name && iconTypes[name];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <Svg as={IconType as FC<any>} className={className} title={title} />;
};
